import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Stack, Typography } from '@mui/material';

import { StrategySummary } from '../../../types/strategySummary';
import { Option } from '../index';

type Props = {
  strategy: StrategySummary;
  options: Option[];
};

export const StrategyParams: React.FC<Props> = ({ strategy, options }) => (
  <Accordion
    disableGutters
    sx={{
      '&:before': { display: 'none' },
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-label={`Параметры стратегии ${strategy.name}`} tabIndex={0}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Chip
          size="small"
          label={strategy.isRestricted ? 'Закрыта' : 'Активна'}
          color={strategy.isRestricted ? 'error' : 'success'}
          sx={{ minWidth: 72 }}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
          {strategy.name}
        </Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Stack spacing={1.5}>
        {options.map((option, ind) => (
          <Stack key={ind} direction="row" spacing={1} sx={{ alignItems: 'baseline' }}>
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 260, flexShrink: 0 }}>
              {option.name}:
            </Typography>
            <Typography variant="body2" component="div">
              {option.formatter ? option.formatter(strategy, option.accessor) : String(strategy[option.accessor] ?? '')}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </AccordionDetails>
  </Accordion>
);
